import "@/index.css";

// Constants
const LOGO_URL = "https://tagmango.com/assets/gurukul-logo-e120d61d51ff255cdf556f51dd573374.png";
const CHALLENGE_PAYMENT_LINK = "https://community.gurukulsistersfamily.com/web/checkout/6adab027ea7ccf718fe54f78";

// Image URLs for blueprints
const IMAGES = {
  1: "https://tagmango.com/assets/01-cover-0f8e5fc557132270908a6a2f7397a87d.png",
  2: "https://tagmango.com/assets/02-100-health-conditions-list-01bc5496fd38671248d09d4ba72da89a.png",
  3: "https://tagmango.com/assets/03-blueprint-01-page-1-d7fc48ffde1dd50b0d65b2f488744f18.png",
  4: "https://tagmango.com/assets/04-blueprint-01-page-2-aaba40cf2293a3fee743e9ccdc8c083b.png",
  5: "https://tagmango.com/assets/05-blueprint-02-page-1-9d52d4b500087ed3389c1d22b87103eb.png",
  6: "https://tagmango.com/assets/06-blueprint-02-page-2-7f7f39141cd37aa972b3614648b6ffdf.png",
  7: "https://tagmango.com/assets/07-blueprint-03-page-1-5e24b4d60be1718a537b0c58877a9380.png",
  8: "https://tagmango.com/assets/08-blueprint-03-page-2-d26f7987dc2ab0d2599e8c4c0b5d35d1.png",
  9: "https://tagmango.com/assets/09-blueprint-04-page-1-8713a5a3fd44f3cb7614b7a05b2a53e1.png",
  10: "https://tagmango.com/assets/10-blueprint-04-page-2-d9f4ea0240bbeebfae0bde8fe06a8c5c.png",
  11: "https://tagmango.com/assets/11-blueprint-05-page-1-313d8e28f2ad7ad2f08e796f3e2a7650.png",
  12: "https://tagmango.com/assets/12-blueprint-05-page-2-6a99eb2fb0242b71cc017b7cb6d825e9.png",
  13: "https://tagmango.com/assets/13-blueprint-06-page-1-afff4ec9ab46085c8e4746f31596814a.png",
  14: "https://tagmango.com/assets/14-blueprint-06-page-2-49db4c8889d2548d1c30401912a8f42d.png",
  15: "https://tagmango.com/assets/15-blueprint-07-page-1-28fc73a37aece7493c0df614a4f34967.png",
  16: "https://tagmango.com/assets/16-blueprint-07-page-2-e130f99a7cfe64513244bc81e9bb256e.png",
  17: "https://tagmango.com/assets/17-blueprint-08-page-1-8a172e41a0fd694695edeb87a2cf484f.png",
  18: "https://tagmango.com/assets/18-blueprint-08-page-2-50386e587571a69d42b759163ed17a8b.png",
  19: "https://tagmango.com/assets/19-blueprint-09-page-1-30209afa3303418fe47bdea314475fdc.png",
  20: "https://tagmango.com/assets/20-blueprint-09-page-2-2aff5282d820a7ba89a0a87937f3ac42.png",
  21: "https://tagmango.com/assets/21-blueprint-10-page-1-b99fdd2e23a834de51ccb64f215a3a4e.png",
  22: "https://tagmango.com/assets/22-blueprint-10-page-2-e2b14a00a618bd5bddfb9339e9bc2063.png",
  23: "https://tagmango.com/assets/23-closing-924dc0888c3405f9d1e7901d2050fb6f.png",
};

// YouTube Shorts Video IDs
const VIDEO_1_ID = "iX04SA2NJtU";
const VIDEO_2_ID = "yNXwqZwUpj0";

const LandingPage = () => {
  return (
    <>
      {/* Header */}
      <header className="top" data-testid="header">
        <img src={LOGO_URL} alt="Gurukul Sisters Family" />
        <p className="tag">Only for women · Join live from anywhere in the world</p>
      </header>

      {/* Hero Section */}
      <section style={{ paddingTop: '6px' }} data-testid="hero-section">
        <div className="wrap">
          <span className="badge">🪔 Diwali Special Offer for 108 sisters</span>
          <div className="plate">
            <h1>Diamond Legacy<br /><span style={{ fontStyle: 'italic', fontSize: '22px' }}>(10 Blueprints)</span></h1>
          </div>
          <p className="lead" style={{ marginTop: '14px', fontWeight: 700, color: 'var(--red)', letterSpacing: '0.04em', fontSize: '14px' }}>YOUR DREAM CAREER IN HOLISTIC HEALTH</p>
          <p className="hero-sub" style={{ fontSize: '30px', marginTop: '4px', whiteSpace: 'nowrap' }}>Become a <span>Health Coach</span></p>
          <p className="lead" style={{ marginTop: '8px', fontWeight: 700, color: 'var(--ink)' }}>10 blueprints, 100 health conditions, 4 months live training</p>
          <p className="lead" style={{ marginTop: '8px' }}>Master the Gurukul holistic approach to 100 common health conditions, for yourself, your family and the people who come to you.</p>
          <a className="btn" href={CHALLENGE_PAYMENT_LINK} data-testid="hero-cta">Join 5 days live for ₹99<small>Live, from anywhere in the world · then decide</small></a>
          <div className="trust">
            <div><b>10,000+</b><span>Gurukul sisters</span></div>
            <div><b>48+</b><span>Indian cities</span></div>
            <div><b>12+</b><span>Countries</span></div>
          </div>
          <p className="usa">System run by USA Gurukul</p>
        </div>
      </section>

      {/* Your New Identity Section */}
      <section className="feel" data-testid="identity-section">
        <div className="wrap">
          <h2>Your new identity</h2>
          <div className="identity-card">
            <span className="icon">🩺</span>
            <div>
              <b>Internationally Certified Health Coach</b>
              <span>Master the 6 pillars of holistic health</span>
            </div>
          </div>
          <div className="ben" style={{ marginTop: '14px' }}>
            <div className="bn" style={{ background: '#fff' }}><span className="n">🥗</span><div><b>Food</b><span>Diet and nutrition</span></div></div>
            <div className="bn" style={{ background: '#fff' }}><span className="n">🧘‍♀️</span><div><b>Body</b><span>Modified workouts and yoga for each health condition</span></div></div>
            <div className="bn" style={{ background: '#fff' }}><span className="n">🧠</span><div><b>Mind</b><span>Meditation and mindfulness</span></div></div>
            <div className="bn" style={{ background: '#fff' }}><span className="n">🌿</span><div><b>Naturopathy</b><span>Herbs and natural healing</span></div></div>
            <div className="bn" style={{ background: '#fff' }}><span className="n">🕊️</span><div><b>Spiritual</b><span>Emotional healing and inner transformation</span></div></div>
            <div className="bn" style={{ background: '#fff' }}><span className="n">💧</span><div><b>Detox</b><span>Clean your body from the inside</span></div></div>
          </div>
          <p className="lead" style={{ marginTop: '16px', fontWeight: 600, color: 'var(--ink)' }}>With the Gurukul holistic approach, master holistic solutions for 100 common health conditions.</p>
          <p className="quote" style={{ marginTop: '14px' }}>Every woman deserves the power to heal herself, her family and her future.</p>
        </div>
      </section>

      {/* What You Can Do Section */}
      <section data-testid="benefits-section">
        <div className="wrap">
          <h2>As a Health Coach, you can</h2>
          <div className="ben">
            <div className="bn"><span className="n">💛</span><div><b>Care for yourself and your family</b><span>Understand your body and guide your home with confidence</span></div></div>
            <div className="bn"><span className="n">🩺</span><div><b>Offer personal health coaching</b><span>One-to-one guidance with diet, yoga, breath and daily routine</span></div></div>
            <div className="bn"><span className="n">👥</span><div><b>Run group health programs</b><span>Weight, hormones, stress and more, the Gurukul way</span></div></div>
            <div className="bn"><span className="n">🌅</span><div><b>Lead health workshops and events</b><span>Share the holistic approach with your community</span></div></div>
          </div>
        </div>
      </section>

      {/* Earning Potential Section */}
      <section className="why" data-testid="earning-section">
        <div className="wrap">
          <h2>Your earning potential</h2>
          <p style={{ fontSize: '17px', marginTop: '6px', opacity: 0.95 }}>Look around your own family and relatives. So many people live with a health problem and need someone to guide them.</p>
          <div className="earning-box">
            <span>EARNING POTENTIAL</span>
            <b>₹10,000 to ₹1,00,000</b>
            <span className="label">per client</span>
          </div>
          <ul>
            <li>Many families spend lakhs on long-term health problems</li>
            <li>A Health Coach gives them a natural, holistic way to support their health</li>
            <li>That is why clients happily invest in good coaching</li>
            <li>You decide how many clients you work with, so you decide your income</li>
          </ul>
          <p style={{ fontSize: '13px', opacity: 0.7, marginTop: '14px' }}>This is an earning potential, not a promise or guarantee. What you earn depends on your clients, your effort and your consistency.</p>
        </div>
      </section>

      {/* 10 Diamond Blueprints Section */}
      <section style={{ paddingTop: '8px' }} data-testid="blueprints-section">
        <div className="wrap">
          <h2>The 10 Diamond Blueprints</h2>
          <p className="lead">10 blueprints covering 100 common health conditions, from hormones and weight to digestion, stress and sleep.</p>
          <ul className="bpl">
            <li><b className="n">1</b><div><strong>Women's Hormonal Balance</strong><span>Balance your hormones, transform your health</span></div></li>
            <li><b className="n">2</b><div><strong>Women's Weight Transformation</strong><span>Shape your body, elevate your confidence</span></div></li>
            <li><b className="n">3</b><div><strong>Pain-Free Joint &amp; Bone Healing</strong><span>Rebuild strength, move pain-free</span></div></li>
            <li><b className="n">4</b><div><strong>Healthy Heart &amp; Lungs Care</strong><span>Breathe better, live stronger</span></div></li>
            <li><b className="n">5</b><div><strong>Diabetes &amp; Lifestyle Healing</strong><span>Take control of your health, naturally</span></div></li>
            <li><b className="n">6</b><div><strong>Goodbye Gas, Acidity &amp; Bloating</strong><span>Gut healing and digestive detox</span></div></li>
            <li><b className="n">7</b><div><strong>Ageless Beauty &amp; Anti-Aging Glow</strong><span>Glow from within, stay young naturally</span></div></li>
            <li><b className="n">8</b><div><strong>Brain &amp; Nerve Health Care</strong><span>Calm the nerves, ease the pain</span></div></li>
            <li><b className="n">9</b><div><strong>Sexual, Urinary &amp; Infection Healing</strong><span>Reclaim intimacy, restore strength</span></div></li>
            <li><b className="n">10</b><div><strong>Stress Free Living</strong><span>Heal the mind, strengthen the soul</span></div></li>
          </ul>
        </div>
      </section>

      {/* 4 Months Training Section */}
      <section className="why" data-testid="training-section">
        <div className="wrap">
          <h2>4 months of live training</h2>
          <ul>
            <li><span><b>Live classes:</b> learn every blueprint live, with a real teacher</span></li>
            <li><span><b>Practise on yourself first:</b> your own health becomes your first success story</span></li>
            <li><span><b>Diet, yoga, breath and routine:</b> the complete holistic toolkit</span></li>
            <li><span><b>Personal counselling skills:</b> learn how to guide one person at a time</span></li>
            <li><span><b>Certification:</b> become a Certified Gurukul Health Coach</span></li>
          </ul>
        </div>
      </section>

      {/* Every Blueprint Page by Page Section */}
      <section style={{ paddingTop: '8px' }} data-testid="pictures-section">
        <div className="wrap">
          <h2>Every blueprint, page by page</h2>
          <p className="lead">Scroll through the 100 health conditions and all 10 blueprints below: who each one is for, what you learn and practise, and the results you work towards.</p>
          <div className="picgrid">
            {/* Pictures 01-08 are available */}
            <img src={IMAGES[1]} alt="Cover - Diamond Legacy 10 Blueprints" />
            <img src={IMAGES[2]} alt="100 Health Conditions List" />
            <img src={IMAGES[3]} alt="Blueprint 1 - Women's Hormonal Balance Page 1" />
            <img src={IMAGES[4]} alt="Blueprint 1 - Women's Hormonal Balance Page 2" />
            <img src={IMAGES[5]} alt="Blueprint 2 - Women's Weight Transformation Page 1" />
            <img src={IMAGES[6]} alt="Blueprint 2 - Women's Weight Transformation Page 2" />
            <img src={IMAGES[7]} alt="Blueprint 3 - Pain-Free Joint & Bone Healing Page 1" />
            <img src={IMAGES[8]} alt="Blueprint 3 - Pain-Free Joint & Bone Healing Page 2" />
            <img src={IMAGES[9]} alt="Blueprint 4 - Healthy Heart & Lungs Care Page 1" />
            <img src={IMAGES[10]} alt="Blueprint 4 - Healthy Heart & Lungs Care Page 2" />
            <img src={IMAGES[11]} alt="Blueprint 5 - Diabetes & Lifestyle Healing Page 1" />
            <img src={IMAGES[12]} alt="Blueprint 5 - Diabetes & Lifestyle Healing Page 2" />
            <img src={IMAGES[13]} alt="Blueprint 6 - Goodbye Gas, Acidity & Bloating Page 1" />
            <img src={IMAGES[14]} alt="Blueprint 6 - Goodbye Gas, Acidity & Bloating Page 2" />
            <img src={IMAGES[15]} alt="Blueprint 7 - Ageless Beauty & Anti-Aging Glow Page 1" />
            <img src={IMAGES[16]} alt="Blueprint 7 - Ageless Beauty & Anti-Aging Glow Page 2" />
            <img src={IMAGES[17]} alt="Blueprint 8 - Brain & Nerve Health Care Page 1" />
            <img src={IMAGES[18]} alt="Blueprint 8 - Brain & Nerve Health Care Page 2" />
            <img src={IMAGES[19]} alt="Blueprint 9 - Sexual, Urinary & Infection Healing Page 1" />
            <img src={IMAGES[20]} alt="Blueprint 9 - Sexual, Urinary & Infection Healing Page 2" />
            <img src={IMAGES[21]} alt="Blueprint 10 - Stress Free Living Page 1" />
            <img src={IMAGES[22]} alt="Blueprint 10 - Stress Free Living Page 2" />
            <img src={IMAGES[23]} alt="Closing - Certified Health Coach" />
          </div>
          <p className="note" style={{ marginTop: '12px' }}>Gurukul teaches yoga, breathwork, meditation, food and lifestyle habits. It is not medical treatment and does not replace your doctor's advice.</p>
          <a className="btn" href={CHALLENGE_PAYMENT_LINK} data-testid="pictures-cta">Join 5 days live for ₹99</a>
        </div>
      </section>

      {/* 5-Day Live Experience Section */}
      <section style={{ paddingTop: '8px' }} data-testid="five-day-section">
        <div className="wrap">
          <div className="five-box">
            <h3>Join the 5-Day Live Experience</h3>
            <p><b>Live, from anywhere in the world.</b> 5 real live classes with Gurukul for just ₹99. Feel the Gurukul way for yourself, then decide where to begin.</p>
            <div className="price" style={{ color: '#fff' }}>
              <s>₹500</s>
              <b style={{ color: 'var(--gold)' }}>₹99</b>
              <em style={{ color: '#fff' }}>5 live classes<br />Online</em>
            </div>
            <p>During the 5 days, Gurukul shares the <b style={{ color: 'var(--gold)' }}>biggest Diwali fee support for Diamond Legacy</b>, only for 108 sisters.</p>
            <div className="batch-times">
              <b>4 online live batches every day (India time)</b>
              <span>🌅 5:00 am – 6:00 am</span>
              <span>☀️ 10:00 am – 11:00 am</span>
              <span>🌤️ 3:30 pm – 4:30 pm</span>
              <span>🌙 8:00 pm – 9:00 pm</span>
              <span className="note">After you register, the Gurukul Team will call you to confirm your batch.</span>
            </div>
            <a className="btn" href={CHALLENGE_PAYMENT_LINK} data-testid="five-day-cta">Join 5 days live for ₹99</a>
          </div>
        </div>
      </section>

      {/* How to Start Section */}
      <section style={{ paddingTop: '8px' }} data-testid="steps-section">
        <div className="wrap">
          <h2>How to start</h2>
          <div className="steps">
            <div className="st"><span className="k">1</span><div><b>Register for the 5-Day Live Experience</b><span>Fill in your details and pay ₹99</span></div></div>
            <div className="st"><span className="k">2</span><div><b>Join 5 days live, from anywhere</b><span>Real live classes, from your home, anywhere in the world</span></div></div>
            <div className="st"><span className="k">3</span><div><b>Then decide where to begin</b><span>Discover Diamond Legacy and your Diwali fee support, with full clarity</span></div></div>
          </div>
        </div>
      </section>

      {/* Why Sisters Trust Gurukul Section */}
      <section className="why" data-testid="trust-section">
        <div className="wrap">
          <h2>Why sisters trust Gurukul</h2>
          <ul>
            <li>System run by USA Gurukul</li>
            <li>Live training, not just recordings</li>
            <li>Live online, join from anywhere in the world</li>
            <li>10,000+ sisters in 48+ cities and 12+ countries</li>
            <li>Internationally certified Gurukul sisters</li>
          </ul>
        </div>
      </section>

      {/* Testimonials Section - YouTube Shorts */}
      <section data-testid="testimonials-section">
        <div className="wrap">
          <h2>Hear from our sisters</h2>
          <div className="ph">
            <div className="video-wrapper">
              <iframe
                src={`https://www.youtube.com/embed/${VIDEO_1_ID}`}
                title="Sister Testimonial 1"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                loading="lazy"
              />
            </div>
            <div className="video-wrapper">
              <iframe
                src={`https://www.youtube.com/embed/${VIDEO_2_ID}`}
                title="Sister Testimonial 2"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section style={{ paddingTop: '8px' }} data-testid="faq-section">
        <div className="wrap">
          <h2>Your questions</h2>
          <details>
            <summary>Why is the fee not shown here?</summary>
            <p>Because we want you to experience Gurukul first. During the 5-Day Live Experience, you get the full details and the biggest Diwali fee support, only for 108 sisters.</p>
          </details>
          <details>
            <summary>What is the 5-Day Live Experience?</summary>
            <p>5 real live classes with Gurukul for ₹99, live from anywhere in the world. Feel the Gurukul way first, then decide where to begin.</p>
          </details>
          <details>
            <summary>How long is the Health Coach training?</summary>
            <p>4 months of live training, covering all 10 blueprints.</p>
          </details>
          <details>
            <summary>Do I need a medical or yoga background?</summary>
            <p>No. Everything is taught step by step, from the beginning.</p>
          </details>
          <details>
            <summary>Is this medical treatment?</summary>
            <p>No. Gurukul teaches yoga, breathwork, meditation, food and lifestyle habits. It does not replace a doctor's advice, and as a Health Coach you work alongside doctors, not instead of them.</p>
          </details>
          <details>
            <summary>Can I join from another city or country?</summary>
            <p>Yes. The training is live and online, so you can join from anywhere in the world.</p>
          </details>
          <details>
            <summary>What are the batch timings?</summary>
            <p>There are 4 online live batches every day (India time): 5–6 am, 10–11 am, 3:30–4:30 pm and 8–9 pm. After you register, the Gurukul Team will call you to confirm your batch.</p>
          </details>
          <details>
            <summary>How much can I earn as a Health Coach?</summary>
            <p>The earning potential is ₹10,000 to ₹1,00,000 per client. It is a potential, not a guarantee. What you earn depends on your clients, your effort and your consistency.</p>
          </details>
        </div>
      </section>

      {/* Contact Section */}
      <section style={{ paddingTop: 0 }} data-testid="contact-section">
        <div className="wrap">
          <p className="lead">Have a question? Talk to the Gurukul Team.</p>
          <a className="wa" href="https://wa.me/917304611933">💬 WhatsApp +91 73046 11933</a>
        </div>
      </section>

      {/* Footer */}
      <footer data-testid="footer">
        <p className="five">Health · Wealth · Love · Happiness · Freedom</p>
        <small>SYSTEM RUN BY USA GURUKUL</small>
      </footer>

      {/* Sticky Bottom Bar */}
      <div className="bar" data-testid="sticky-bar">
        <div className="p">
          <s>₹500</s>
          <b>₹99</b>
        </div>
        <a href={CHALLENGE_PAYMENT_LINK} data-testid="sticky-cta">Join 5 days live</a>
      </div>
    </>
  );
};

function App() {
  return <LandingPage />;
}

export default App;
